import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatCEP',
    standalone: false
})
export class FormatCEPPipe implements PipeTransform {

  transform(value: any, args?: any): any {    
    
    if(value == null || value == "")
      return value

      return value.replace(/^(\d{5})(\d{3}).*/, '$1-$2');
  }

}